import { DefaultRegistrationConfig } from './registrationConfig.constants';
import {
  RegistrationConfigState,
  RegistrationStep,
} from './registrationConfig.types';
import {
  createAsyncThunk,
  createSlice,
  injectSlice,
  PayloadAction,
} from '@betty/toolkit/state';

export const fetchRegistrationConfig = createAsyncThunk(
  'registration/config',
  () => DefaultRegistrationConfig,
);

const initialState: RegistrationConfigState = {
  data: DefaultRegistrationConfig,
  dataState: 'idle',
};

const registrationConfig = createSlice({
  name: 'registrationConfig',
  initialState,
  reducers: {
    removeStep(state, action: PayloadAction<RegistrationStep['id']>) {
      state.data.steps = state.data.steps.filter(
        (step) => step.id !== action.payload,
      );
    },
    skipStep(state, action: PayloadAction<RegistrationStep['id']>) {
      const steps = state.data.steps.map((step) => {
        if (step.id === action.payload) {
          return { ...step, skip: true };
        }

        return step;
      });

      state.data = {
        ...state.data,
        steps,
      };
    },
    restoreStep(state, action: PayloadAction<RegistrationStep['id']>) {
      const steps = state.data.steps.map((step) => {
        if (step.id === action.payload) {
          return { ...step, skip: false };
        }

        return step;
      });

      state.data = {
        ...state.data,
        steps,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchRegistrationConfig.pending, (state) => {
      state.dataState = 'pending';
    });
    builder.addCase(fetchRegistrationConfig.fulfilled, (state, action) => {
      state.dataState = 'fulfilled';
      state.data = action.payload;
    });
    builder.addCase(fetchRegistrationConfig.rejected, (state) => {
      state.dataState = 'rejected';
    });
  },
});

export const withRegistrationConfig = injectSlice({
  reducerPath: 'registrationConfig',
  reducer: registrationConfig.reducer,
});

export const { removeStep, skipStep, restoreStep } = registrationConfig.actions;

export const selectRegistrationConfig = withRegistrationConfig.selector(
  (state) => state.registrationConfig.data,
);

export const selectRegistrationConfigDataState =
  withRegistrationConfig.selector(
    (state) => state.registrationConfig.dataState,
  );

declare global {
  interface LazyLoadedSlices {
    registrationConfig: ReturnType<typeof registrationConfig.reducer>;
  }
}
